<!-- h5/视频 -->
<template>
  <div class="box">
    <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">
      <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="list.length > 0 ? '没有更多了' : ''"
          @load="getList2"
      >
        <ul class="video-list">
<!--          <li v-for="(item, index) in list" :key="index" @click.stop="$router.push(`/video-details?id=${item.id}&videoArrId=${item.videoArrId}`)">-->

<!--            <div class="video-box" v-if="index % 7 === 0">-->
<!--              <div class="video-box-top">-->
<!--                <img :src="item.cover" class="img-box-img">-->
<!--              </div>-->
<!--              <div class="video-box-bottom">-->
<!--                <p class="video-box-name">{{ item.title }}</p>-->

<!--                <button class="circle-btn" @click.stop="reportParams.report_id = item.id; showReport = true">-->
<!--                  <img src="../assets/icon.png" class="circle-img">-->
<!--                </button>-->
<!--                &lt;!&ndash;              <img src="../assets/icon.png" class="circle-img" @click.stop="reportParams.report_id = item.id; showReport = true">&ndash;&gt;-->
<!--              </div>-->
<!--              <span class="video-box-tag" v-if="item.is_vip">VIP</span>-->
<!--            </div>-->

<!--            <div v-else>-->
<!--              <div class="img-box">-->
<!--                <img :src="item.cover" class="img-box-img">-->
<!--                <span class="img-box-tag">{{ item.create_at }}</span>-->
<!--                <span class="video-box-tag" v-if="item.is_vip">VIP</span>-->
<!--              </div>-->
<!--              <div class="video-item-bottom">-->
<!--                <p class="video-item-title">{{ item.title }}</p>-->
<!--                <div class="video-item-row-between">-->
<!--                  <div class="video-item-row-left">-->
<!--                    <img src="../assets/avatar.png" class="video-item-row-avatar">-->
<!--                    <span class="video-item-row-name">{{ item.label_name.join(',') }}</span>-->
<!--                  </div>-->

<!--                  <button class="circle-btn" @click.stop="reportParams.report_id = item.id; showReport = true">-->
<!--                    <img src="../assets/icon.png" class="circle-img">-->
<!--                  </button>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </li>-->


          <li v-for="(item, index) in list" :key="index" @click.stop="$router.push(`/video-details?id=${item.video_id}&videoArrId=${item.id}`)">

            <div class="video-box" v-if="index % 7 === 0">
              <div class="video-box-top">
                <img :src="item.cover" class="img-box-img">
              </div>
              <div class="video-box-bottom">
                <p class="video-box-name">{{ item.title }}</p>
                <button class="circle-btn" @click.stop="reportParams.report_id = item.video_id; showReport = true">
                  <img src="../assets/icon.png" class="circle-img">
                </button>
              </div>
              <span class="video-box-tag" v-if="item.is_vip">VIP</span>
            </div>

            <div v-else>
              <div class="img-box">
                <img :src="item.cover" class="img-box-img">
                <span class="img-box-tag">{{ item.create_at }}</span>
                <span class="video-box-tag" v-if="item.is_vip">VIP</span>
              </div>
              <div class="video-item-bottom">
                <p class="video-item-title">{{ item.title }}</p>
                <div class="video-item-row-between">
                  <div class="video-item-row-left">
                    <img :src="item.app_logo" class="video-item-row-avatar">
                    <span class="video-item-row-name">{{ item.app_name }}</span>
                  </div>

                  <button class="circle-btn" @click.stop="reportParams.report_id = item.video_id; showReport = true">
                    <img src="../assets/icon.png" class="circle-img">
                  </button>
                </div>
              </div>
            </div>
          </li>
          <!-- 无数据时显示 -->
          <div class="normal-box" v-if="list.length === 0">
            <img src="../assets/normal.png">
            暂无数据
          </div>
        </ul>
        <!-- 举报弹窗 -->
        <van-popup v-model="showReport" round position="bottom">
          <div class="window" style="position: relative!important">
            <div class="window-top">
              <button type="button" class="window-btn del"
                      style="justify-content: flex-start"
                      @click.stop="showReport = false; $router.push(`/report?type=${reportParams.type}&id=${reportParams.report_id}`)">
                <img src="../assets/icon-8.png">举报
              </button>
            </div>
            <div class="window-btn-box" @click="showReport = false">
              <button type="button">取消</button>
            </div>
          </div>
        </van-popup>
      </van-list>
    </van-pull-refresh>
  </div>

</template>

<script>
	import {VideoService} from "@/common/service";

  export default {
		components: {},
		data() {
			return {
        showReport: false,
        // 举报参数
        reportParams: {
          type: 1,  // 举报类型（1视频2评论3会员）
          report_id: 0,  // 举报内容的id
        },
        params: {
          type: 0,  // 类型1单个2系列
          is_tj: 1,  // 是否推荐0否1是
          page: 1,  // 页数
          page_num: 20,  // 每页数
        },
        list: [],
        loading: false,
        finished: false,

        refreshLoading: false, // 下拉刷新
			};
		},
    methods: {
      onRefresh() {
        this.params.page = 1;
        this.finished = false;
        this.getList2();
      },
      getList2() {
        this.loading = true;
        VideoService.getRecommendVideoList()
            .then(({ data }) => this.list = data)
            .finally(() => {
              this.finished = true;
              this.loading = false;
              this.refreshLoading = false;
            });
      },
      getList() {
        this.loading = true;
        VideoService.getVideoList(this.params).then(({ data }) => {
          // 展开集合视频，并合并到列表
          const list = data.list.reduce((arr, item) => {
            const {id, label_name, video_arr} = item;
            // 展开集合视频
            const newList = video_arr.map(item2 => ({
              ...item2,
              videoArrId: item2.id,
              id,
              label_name,
              video_arr,
            }))
            // 判断是否是集合，是则将集合合并到列表
            if (video_arr.length > 1) {
              arr.push({ ...video_arr[0], videoArrId: video_arr[0].id, ...item});
            }
            // 集合视频合并到列表
            arr.push(...newList);
            return arr;
          }, []);
          this.list = this.params.page === 1 ? list : [...this.list, ...list];
          if (list.length < this.params.page_num) {
            this.finished = true;
          } else {
            this.params.page++;
          }
        }).finally(() => {
          this.loading = false;
          this.refreshLoading = false;
        });
      },
    },
	}
</script>

<style scoped>

  .van-list{
    min-height: calc(var(--vh) * 100 - 84px);
    overflow: hidden;
  }

  .box{
    height: calc(var(--vh) * 100 - 84px);
    overflow: auto;
  }

	.video-box {
		width: 100%;
		height: fit-content;
		display: flex;
		flex-direction: column;
		background-color: #FFFFFF;
		border-radius: 10px;
		box-shadow: 0 1px 16px rgba(0, 0, 0, 0.12);
		/*margin-bottom: 10px;*/
		position: relative;
	}

	.video-box-top {
		width: 100%;
		height: 164px;
	}

	.video-box-bottom {
		width: 100%;
		height: 42px;
		line-height: 42px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 10px;
		box-sizing: border-box;
	}

	.video-box-name {
		flex: 1;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		color: #222222;
		font-weight: 500;
		font-size: 15px;
	}

  .circle-btn {
    width: 25px;
    height: 15px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .circle-img {
    width: 3px;
  }


	.video-box-tag {
		position: absolute;
		right: 0;
		top: 0;
		width: 34px;
		line-height: 14px;
		height: 14px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 0 7px 0 7px;
		background-color: #F3D170;
		color: #78581D;
		font-weight: 500;
		font-size: 12px;
	}

	.video-list {
		width: 100%;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.video-list>li {
		width: calc(50% - 7.5px);
		background-color: #FFFFFF;
		display: flex;
		flex-direction: column;
		margin-bottom: 12px;
		border-radius: 10px;
		box-shadow: 0 1px 16px rgba(0, 0, 0, 0.12);
		overflow: hidden;
	}
  .video-list>li:nth-child(7n + 1) {
    width: 100%;
  }

	.img-box {
		width: 100%;
		height: 92px;
		border-radius: 10px;
		overflow: hidden;
		position: relative;
	}

	.img-box-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.img-box-tag {
		position: absolute;
		right: 6px;
		bottom: 5px;
		font-size: 11px;
		color: #FFFFFF;
	}

	.video-item-bottom {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 6px 10px 10px;
		box-sizing: border-box;
	}

	.video-item-title {
		width: 100%;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		color: #222222;
		font-size: 14px;
		margin-bottom: 3px;
	}

	.video-item-row-between {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.video-item-row-left {
		flex: 1;
		display: flex;
		align-items: center;
	}

	.video-item-row-avatar {
		width: 14px;
		height: 14px;
		border-radius: 50%;
		margin-right: 4px;
		object-fit: cover;
	}

	.video-item-row-name {
		flex: 1;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		color: #999999;
		font-size: 12px;
	}

	.float-box {
		width: 46px;
		height: 46px;
		border-radius: 50%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		color: #FFFFFF;
		font-size: 10px;
		font-weight: 500;
		box-shadow: 0 1px 8px rgba(42, 99, 243, 0.6);
		position: fixed;
		right: 15px;
		top: 50%;
		background-color: #2A63F3;
	}

	.float-box>img {
		width: 16px;
	}

	.window {
		width: 100%;
		display: flex;
		flex-direction: column;
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 99999999;
	}

	.mask-layer {
		width: 100%;
		height: calc(var(--vh) * 100);
		background: rgba(34, 34, 34, 0.92);
		position: fixed;
		left: 0;
		top: 0;
		z-index: 999999;
	}

	.normal-box {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 14px;
		color: #999992;
		padding: 100px 0;
	}
	
	.normal-box>img {
		width: 150px;
		margin-bottom: 9px;
	}

  .window {
    width: 100%;
    display: flex;
    flex-direction: column;
    /*position: fixed;*/
    /*bottom: 0;*/
    /*left: 0;*/
    z-index: 99999999;
    background-color: #FFFFFF;
    border-radius: 16px 16px 0 0;
  }

  .mask-layer {
    width: 100%;
    height: calc(var(--vh) * 100);
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
  }

  .window-top {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 35px 25px;
    box-sizing: border-box;
  }

  .window-top2 {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 25px 25px 23px;
    box-sizing: border-box;
  }

  .window-btn {
    width: 100%;
    display: flex;
    align-items: center;
    color: #222222;
    font-size: 16px;
    margin-bottom: 30px;
  }

  .window-btn:last-child {
    margin-bottom: 0;
  }

  .window-btn.del {
    color: #FF1010;
  }

  .window-btn>img {
    width: 24px;
    margin-right: 16px;
  }

  .window-btn2 {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #333333;
    font-size: 13px;
  }

  .window-btn2>img {
    height: 38px;
    margin-bottom: 5px;
  }

  .window-btn-box {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 15px 38px;
    box-sizing: border-box;
  }

  .window-btn-box>button {
    width: 100%;
    height: 40px;
    line-height: 40px;
    background-color: #F3F3F3;
    border-radius: 100px;
    color: #222222;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .window-btn-box2 {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 14px 0 47px;
    box-sizing: border-box;
    border-top: 1px solid #F2F2F2;
  }

  .window-btn-box2>button {
    color: #999999;
    font-size: 16px;
  }
</style>
